import React from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./components/Auth/AuthConfig.jsx";
import { HashRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import AppLogin from "./components/Auth/AppLogin.jsx";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import store from "./store/index";
import "./assets/css/main.css";
import "./assets/css/custom.css";
import './appMonitor.js'

const root = createRoot(document.getElementById("root"));

export const msalInstance = new PublicClientApplication(msalConfig);

root.render(
  <MsalProvider instance={msalInstance}>
    <HashRouter>
      <Provider store={store}>
        <AppLogin />
      </Provider>
    </HashRouter>
  </MsalProvider>
);
